import {createTheme} from '@material-ui/core/styles'

const theme = createTheme({
  palette: {
    type: "dark"
  },
});

export default theme